import { Inventory, Outbox, ShoppingCart } from '@mui/icons-material';
import { Grid } from '@mui/material';
import React from 'react';
import DashInfobox2 from './infoboxes/DashInfobox2';

const DashMinInfoboxes = () => {
    const infoBox = [
        {
            id: 1,
            head: 'In-Stock',
            subhead: '4320 products',
            icon: <Inventory className="icon" />,
        },
        {
            id: 2,
            head: 'Sold products',
            subhead: '4320 products',
            icon: <ShoppingCart className="icon" />,
        },
        {
            id: 3,
            head: 'Out-of-stocks',
            subhead: '4320 products',
            icon: <Outbox className="icon" />,
        },
    ];
    return (
        <>
            {infoBox.map((item) => (
                <Grid item sm={4} key={item.id}>
                    <DashInfobox2
                        head={item.head}
                        subhead={item.subhead}
                        icon={item.icon}
                    />
                </Grid>
            ))}
        </>
    );
};

export default DashMinInfoboxes;
